<script>
import Loader from "@/components/widgets/loader.vue";
import { notify } from '@/helpers/notify'
import OdemeDuzelt from './odeme_duzelt'
import { getRolename } from "@/helpers/helper"
import PrintMainVue from './PrintMain.vue';

const PAYMENT_LABELS = {
  cek: 'Çek',
  kasa: 'Nakit',
  banka: 'Kredi Kartı',
  havale: 'Havale',
}

export default {
  name: 'PaymentHistoryModal',
  props: ['data'],
  components: {
    OdemeDuzelt,
    Loader,
    PrintMainVue,
  },
  data() {
    return {
      title: '',
      url: '',
      pickMabkuz: false,
      pickFatura: false,
      odemeData: {},
      subsId: 0,
      loading: true,
      showReceiptModal: false,
      isReceiptLoading: false,
      receiptItems: [],
      currentReceiptIndex: 0,
      rows: [],
      type: 'makbuz',
      totalData: {
        bakiyeToplam: 0,
        satisToplam: 0,
        tahsilatToplam: 0,
      },
      modelOpen: 0,
      checkId: [],
      isAdminUser: false,
    }
  },
  watch: {
    data(props) {
      if (!props || !props.id) return
      this.title = `Ödeme Geçmişi > ${props.username || ''}`
      this.url = `/members/${props.id}/balances`
      this.subsId = props.id
      this.checkId = []
      this.pickMabkuz = false
      this.pickFatura = false
      this.loadItems()
    },
  },
  computed: {
    rolename() {
      return getRolename()
    },
    canEdit() {
      return this.isAdminUser && this.rolename === 'admin'
    },
    rowCount() {
      return this.rows.length
    },
  },
  created() {
    try {
      const userdata = JSON.parse(localStorage.getItem('userdata') || '{}')
      this.isAdminUser = userdata.role_name === 'admin'
    } catch (e) {
      this.isAdminUser = false
    }
  },
  methods: {
    paymentTypeLabel(row) {
      if (Number(row.transac_type) === 0) return 'Bayi uzattı'
      if (!row.payment_type_type) return '-'
      const label = PAYMENT_LABELS[row.payment_type_type] || 'Veresiye'
      return row.payment_type_title ? `${label} (${row.payment_type_title})` : label
    },
    saleAmount(row) {
      return Number(row.direction) === 2 ? parseFloat(row.amount || 0) : 0
    },
    collectAmount(row) {
      return Number(row.direction) === 1 ? parseFloat(row.amount || 0) : 0
    },
    loadItems() {
      this.loading = true
      this.$http.post(this.url, {})
        .then((res) => {
          const data = res.data || {}
          this.totalData = {
            bakiyeToplam: data.bakiyeToplam || 0,
            tahsilatToplam: data.tahsilatToplam || 0,
            satisToplam: data.satisToplam || 0,
          }
          const rows = data.data || []
          for (let i = 0; i < rows.length; i++) {
            rows[i].hasReceipt = Number(rows[i].receipts_count) > 0
          }
          this.rows = rows
        })
        .catch(() => notify.error('Ödeme geçmişi yüklenemedi'))
        .finally(() => {
          this.loading = false
        })
    },
    close() {
      this.$parent.$bvModal.hide('payment_history_modal')
    },
    print(type) {
      this.modelOpen = Math.floor(Math.random() * 1000)
      this.type = type
      this.$parent.$bvModal.show('print_modal')
    },
    odemeDuzeltOpen(row) {
      this.odemeData = { ...row, subscription_id: this.subsId }
      this.$parent.$bvModal.show('odeme_duzelt')
    },
    openReceipt(row) {
      const balanceType = 'App\\Models\\CustomerBalance\\SubscriptionBalance'
      this.$http.get('/receipts', { params: { balance_type: balanceType, balance_id: row.id } })
        .then((res) => {
          const items = res.data.data || []
          if (!items.length) {
            notify.info('Dekont bulunamadı.')
            return
          }
          this.receiptItems = items.map((i) => ({
            id: i.id,
            mime: i.mime,
            filename: i.filename,
            blobUrl: null,
          }))
          this.currentReceiptIndex = 0
          this.showReceiptModal = true
          this.isReceiptLoading = true
          this.$nextTick(() => {
            this.$root.$emit('bv::show::modal', 'receipt_modal')
            this.fetchReceiptBlob(this.currentReceiptIndex)
          })
        })
        .catch(() => notify.error('Dekont getirilemedi'))
    },
    fetchReceiptBlob(index) {
      const item = this.receiptItems[index]
      if (!item || item.blobUrl) {
        this.isReceiptLoading = false
        return
      }
      this.$http.get(`/receipts/${item.id}/download`, { responseType: 'blob' })
        .then((res) => {
          const blob = new Blob([res.data], {
            type: res.headers['content-type'] || item.mime || 'application/octet-stream',
          })
          this.$set(this.receiptItems[index], 'blobUrl', URL.createObjectURL(blob))
          this.isReceiptLoading = false
        })
        .catch(() => {
          this.isReceiptLoading = false
          notify.error('Dekont yüklenemedi')
        })
    },
    closeReceipt() {
      this.showReceiptModal = false
      this.receiptItems.forEach((i) => {
        if (i.blobUrl) URL.revokeObjectURL(i.blobUrl)
      })
      this.receiptItems = []
      this.currentReceiptIndex = 0
      this.$root.$emit('bv::hide::modal', 'receipt_modal')
    },
    pick() {
      this.pickMabkuz = this.checkId.some((id) => {
        const row = this.rows.find((r) => r.id === id)
        return row && Number(row.direction) === 1
      })
      this.pickFatura = this.checkId.some((id) => {
        const row = this.rows.find((r) => r.id === id)
        return row && Number(row.direction) === 2
      })
    },
  },
};
</script>

<template>
  <b-modal id="payment_history_modal" size="xl" :title="title" no-close-on-backdrop hide-footer>
    <OdemeDuzelt :data="odemeData" @loadItems="loadItems" />
    <PrintMainVue :data="checkId" :subsId="subsId" :modalopen="modelOpen" :type="type" />

    <div class="ph">
      <div class="ph-summary">
        <div class="ph-summary__item">
          <span>Kayıt</span>
          <strong>{{ rowCount }}</strong>
        </div>
        <div class="ph-summary__item">
          <span>Satış</span>
          <strong>{{ $paraFormat(totalData.satisToplam) }}</strong>
        </div>
        <div class="ph-summary__item">
          <span>Tahsilat</span>
          <strong class="is-collect">{{ $paraFormat(totalData.tahsilatToplam) }}</strong>
        </div>
        <div class="ph-summary__item is-total">
          <span>Bakiye</span>
          <strong>{{ $paraFormat(totalData.bakiyeToplam) }}</strong>
        </div>
      </div>

      <Loader :loading="true" :load="loading">
        <div class="ph-table-wrap" v-if="rows.length">
          <table class="ph-table">
            <thead>
              <tr>
                <th>Fatura / Makbuz</th>
                <th>Ödemeyi Alan</th>
                <th>İşlem Tarihi</th>
                <th>Ödeme Şekli</th>
                <th>İşlem Açıklama</th>
                <th>Açıklama</th>
                <th class="text-end">Satış</th>
                <th class="text-end">Tahsilat</th>
                <th class="text-end">Bakiye</th>
                <th v-if="canEdit"></th>
                <th></th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in rows" :key="row.id">
                <td>{{ row.invoice_num || '-' }}</td>
                <td>{{ row.user_name }}</td>
                <td class="ph-nowrap">{{ row.created_at }}</td>
                <td>{{ paymentTypeLabel(row) }}</td>
                <td>{{ row.main_explaine }}</td>
                <td>{{ row.explaine || '-' }}</td>
                <td class="text-end ph-sale">{{ saleAmount(row) ? $paraFormat(saleAmount(row)) : '-' }}</td>
                <td class="text-end ph-collect">{{ collectAmount(row) ? $paraFormat(collectAmount(row)) : '-' }}</td>
                <td class="text-end ph-balance">{{ $paraFormat(row.balance) }}</td>
                <td v-if="canEdit">
                  <button type="button" class="ph-btn ph-btn--warn" @click="odemeDuzeltOpen(row)">Düzenle</button>
                </td>
                <td>
                  <button v-if="row.hasReceipt" type="button" class="ph-btn ph-btn--link" @click="openReceipt(row)">Dekont</button>
                </td>
                <td class="text-center">
                  <input type="checkbox" :value="row.id" v-model="checkId" @change="pick">
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="ph-empty" v-else>
          <i class="bx bx-receipt"></i>
          <p>Ödeme kaydı bulunamadı</p>
        </div>
      </Loader>

      <div class="ph-actions" v-if="pickMabkuz || pickFatura">
        <button v-if="pickMabkuz" type="button" class="ph-btn ph-btn--primary" @click="print('makbuz')">Makbuz Bas</button>
        <button v-if="pickFatura" type="button" class="ph-btn ph-btn--primary" @click="print('fatura')">Fatura Bas</button>
      </div>
    </div>

    <b-modal id="receipt_modal" size="xl" hide-footer @hidden="closeReceipt">
      <div v-if="receiptItems.length">
        <div class="d-flex justify-content-between mb-2">
          <strong>{{ receiptItems[currentReceiptIndex].filename }}</strong>
        </div>
        <div style="height:75vh; position:relative;">
          <div
            v-if="isReceiptLoading"
            class="position-absolute w-100 h-100 d-flex justify-content-center align-items-center"
            style="background:rgba(255,255,255,0.6);z-index:5"
          >
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
          <iframe
            v-if="receiptItems[currentReceiptIndex].mime === 'application/pdf' && receiptItems[currentReceiptIndex].blobUrl"
            :src="receiptItems[currentReceiptIndex].blobUrl"
            style="width:100%;height:100%;border:0"
          ></iframe>
          <img
            v-else-if="receiptItems[currentReceiptIndex].blobUrl"
            :src="receiptItems[currentReceiptIndex].blobUrl"
            style="max-width:100%;max-height:100%;display:block;margin:auto"
          />
          <div v-else class="text-center p-4">Yükleniyor...</div>
        </div>
      </div>
      <div v-else>
        <p>Gösterilecek dekont yok.</p>
      </div>
    </b-modal>
  </b-modal>
</template>

<style scoped>
.ph { display: flex; flex-direction: column; gap: 14px; }
.ph-summary {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 10px;
}
.ph-summary__item {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 12px 14px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.ph-summary__item span {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #64748b;
}
.ph-summary__item strong {
  font-size: 1.05rem;
  color: #0f172a;
  line-height: 1.2;
}
.ph-summary__item strong.is-collect { color: #2563eb; }
.ph-summary__item.is-total {
  background: linear-gradient(135deg, #ecfdf5, #f0fdf4);
  border-color: #bbf7d0;
}
.ph-summary__item.is-total strong { color: #059669; }
.ph-table-wrap {
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  overflow: auto;
  max-height: 58vh;
  background: #fff;
}
.ph-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  margin: 0;
  font-size: 13px;
}
.ph-table thead th {
  position: sticky;
  top: 0;
  z-index: 1;
  background: #f8fafc;
  color: #64748b;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  padding: 10px 12px;
  border-bottom: 1px solid #e2e8f0;
  white-space: nowrap;
}
.ph-table tbody td {
  padding: 10px 12px;
  border-bottom: 1px solid #f1f5f9;
  color: #334155;
  vertical-align: middle;
}
.ph-table tbody tr:hover { background: #f8fafc; }
.ph-nowrap { white-space: nowrap; }
.ph-sale { color: #dc2626; font-weight: 600; }
.ph-collect { color: #2563eb; font-weight: 600; }
.ph-balance { color: #0f172a; font-weight: 700; }
.ph-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 48px 16px;
  color: #94a3b8;
  border: 1px dashed #e2e8f0;
  border-radius: 12px;
}
.ph-empty i { font-size: 2rem; }
.ph-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}
.ph-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 34px;
  padding: 0 12px;
  border-radius: 8px;
  border: 1px solid transparent;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  background: #fff;
}
.ph-btn--warn {
  border-color: #fde68a;
  background: #fffbeb;
  color: #b45309;
}
.ph-btn--link {
  border-color: #bfdbfe;
  background: #eff6ff;
  color: #2563eb;
}
.ph-btn--primary {
  border: none;
  background: linear-gradient(135deg, #2563eb, #1d4ed8);
  color: #fff;
  height: 40px;
  padding: 0 16px;
}
@media (max-width: 767.98px) {
  .ph-summary { grid-template-columns: repeat(2, minmax(0, 1fr)); }
}
</style>
